<template>
  <v-row justify="center">
    <v-dialog v-model="active" :persistent="fix" max-width="400">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon v-if="!fix" size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{title}}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:80px; font-size:15px">
          {{content}}
        </v-card-text>
        <v-row  justify="center">          
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#7AC7FC"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ShowMsg',
    props:['onSave'],
    data () {
      return {
        active: false,
        title: '',
        content: '',
        onSaveEn: false,
        fix: false,
      }
    },
    methods:{
      open(type = null, title = null, content = null, onSaveEn = false, fix = false){
        this.active = true
        this.onSaveEn = onSaveEn
        this.fix = fix
        switch(type){
          case 0:
          default:
            this.title = title
            this.content = content
            break
          case 1:
            this.title = '請輸入所有必填'
            this.content = '請輸入所有必填。'
            break
          case 2:
            this.title = '已新增資料'
            this.content = '系統已新增此筆資料'
            break
          case 3:
            this.title = '已修改資料'
            this.content = '系統已修改此筆資料'
            break
          case 4:
            this.title = '已刪除資料'
            this.content = '系統已刪除此筆資料。*系統將無法再查詢到相關資料'
            break
          case 5:
            this.title = '已匯入'
            this.content = '系統已將資料匯入!'
            break
          case 6:
            this.title = '圖片不符合規定'
            this.content = '請確認圖片小於80KB，且圖片寬度700像素，高度700像素。'
            break
          //seldom use
          case 11:
            this.title = '總抽題數錯誤'
            this.content = '總抽題數錯誤，請進入抽題設定進行調整。'
            break
          case 12:
            this.title = '已修改通知'
            this.content = '系統已修改此筆通知'
            break
          case 13:
            this.title = '已刪除通知'
            this.content = '系統已刪除此筆通知'
            break
          case 14:
            this.title = '已修改資料'
            this.content = '系統已修改考場須知'
            break
          case 15:
            this.title = '已修改資料'
            this.content = '系統已修改交卷時間'
            break
          case 16:
            this.title = '身份證字號不正確'
            this.content = '請確認身份證是否填寫正確'
            break
          case 17:
            this.title = '總抽題數錯誤'
            this.content = '總抽題數錯誤，請進入「抽題設定」進行調整。'
            break
          case 18:
            this.title = '總抽題數錯誤'
            this.content = '總抽題數錯誤，請進入「抽題設定二」進行調整。'
            break
          case 19:
            this.title = '成績匯回報名系統'
            this.content = '本場次成績已匯回報名系統 ! '
            break
        }
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave()
        }
        this.close()
      }
    }
  }
</script>